import React, { AriaRole } from 'react';
import { useSelector } from 'react-redux';
import { IconAuthenticationOutline, IconAuthenticationFill } from '@saucelabs/ds-icons';

import selectors from '../selectors';
import GenericPopover from './GenericPopover';
import GenericButton from './GenericButton';
import { BiometricAuthenticationPopover } from '../../biometricAuthentication';

const ButtonBiometricAuthentication: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const {
    deviceToolsDisabled,
  } = useSelector(selectors.toolbarButtonSelector);

  return (
    <GenericPopover
      trigger={(
        <GenericButton
          dataQa="live-session-toolbar-biometric-authentication-button"
          disabled={deviceToolsDisabled}
          icon={IconAuthenticationOutline}
          iconHightlight={IconAuthenticationFill}
          isPopoverTrigger
          label="Biometric Authentication"
          role={role || 'menuitem'}
        />
      )}
    >
      <div data-prevent-toolbar-overlay-close>
        <BiometricAuthenticationPopover />
      </div>
    </GenericPopover>
  );
};

ButtonBiometricAuthentication.displayName = 'ButtonBiometricAuthentication';

export default ButtonBiometricAuthentication;
